import React from 'react'
import SliderIndustriesServe from '../../component/slidercomponent/SliderIndustriesServe'
import SliderHomeOurBlog from '../../component/slidercomponent/SliderHomeOurBlog'

const IndustriesServe = () => {
    return (
        <>

           

            <section className="section-blog" style={{ overflow: "hidden", marginTop: "-50px" }}>
                <div className="position-relative z-1 overflow-hidden">
                    <div className="position-relative z-1 overflow-hidden">
                        <div className="section-space">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className=" col-md-10 col-xl-8 col-xxl-7">
                                        <div className="section-content-block text-center" style={{ marginTop: "-40px" }}>
                                            <span className="section-tag is-white"> Welcome to Rahul Logistics </span>
                                            <h2 className="section-title is-text-dark">
                                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                                    Industries We Serve
                                                </div>
                                            </h2>
                                            <p className="section-text">At Rahul Logistics, we understand the unique logistics requirements of different industries. We partner with businesses across sectors to deliver customized logistics solutions that enhance efficiency and reduce costs.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-slider blog-slider-1 swiper swiper-initialized swiper-horizontal swiper-backface-hidden">
                                    <div className="" id="swiper-wrapper-74bccdda5bc3735f" aria-live="polite">
                                        <SliderIndustriesServe />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="blog-bg-img-block">
                            <img src="assets/images/world-map-bg.png" alt="world-map-bg" width={1920} height={1250} className="object-fit-cover" />
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default IndustriesServe